class Controller {
  constructor($log) {
    "ngInject";
    $log.log("It's lost Component");
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/lost/lost.controller.js